<template>
    <div>
        <donut-chart
                     :chart-data="dataCollection"
                     :options="chartOptions"></donut-chart>
    </div>
</template>

<script>
    import DonutChart from '@/components/DonutChart.vue'
    import {AssessmentHistory} from "../state/models/AssessmentHistory";
    import {MathUtils} from "../utils/MathUtils";
    import {ObjectUtils} from "@/utils/ObjectUtils";

    export default {
        name: "ClassHistoryChart",
        components: { DonutChart },
        props: {
            classId: undefined,
            maxNumEntries: undefined,
            startDate: undefined,
            endDate: undefined
        },
        watch: {
            classId(val, oldVal) {
                this.fillData();
            },
            maxNumEntries(val, oldVal) {
                this.fillData();
            },
            startDate(val, oldVal) {
                this.fillData();
            },
            endDate(val, oldVal) {
                this.fillData();
            },
        },
        data() {
            return {
                dataCollection: {},
                chartOptions: {
                    title: 'Class History',
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 50,
                    animation: {
                        animateRotate: true,
                        animateScale: true
                    }
                }
            }
        },
        mounted() {
            this.fillData();
        },
        methods: {
            fillData() {
                this.$store.dispatch('getClasses', ObjectUtils.isNullOrUndefined(this.classId) ? undefined : {ids: [this.classId] })
                    .then((cList) => {
                        if (!cList || !cList.length || !this.classId)  {
                            return Promise.resolve(undefined);
                        }
                        return Promise.resolve(cList[0].studentIds);
                    })
                    .then((studentIds) => {
                        if (ObjectUtils.isNullOrUndefined(studentIds)) {
                            return Promise.resolve(undefined);
                        }
                        return this.$store.dispatch('searchHistory', {
                            studentIds: studentIds,
                            maxNumEntries: this.maxNumEntries || undefined,
                            startDate: this.startDate ? new Date(this.startDate) : undefined,
                            endDate: this.endDate ? new Date(this.endDate) : undefined,
                        });
                    })
                    .then((hList) => {
                        let dataSetAndLabels = this.makeDataSet(hList);
                        this.dataCollection = {
                            labels: ObjectUtils.isNullOrUndefined(dataSetAndLabels) ? [] : dataSetAndLabels.labels,
                            datasets: [{
                                data: ObjectUtils.isNullOrUndefined(dataSetAndLabels) ? [] : dataSetAndLabels.data,
                                backgroundColor: ObjectUtils.isNullOrUndefined(dataSetAndLabels) ? [] : dataSetAndLabels.colors,
                                borderAlign: 'inner'
                            }]
                        };
                    });

            },

            makeDataSet(hList) {
                if (!hList) {
                    return undefined;
                }
                let studentScoresMap = new Map();
                hList.forEach(h => {
                    let scoreList = studentScoresMap.get(h.studentId);
                    let score = h.countPercentageCorrect();
                    if (scoreList) {
                        scoreList.push(score);
                    }
                    else {
                        studentScoresMap.set(h.studentId, [score]);
                    }
                });

                let listOfAverages = Array.from(studentScoresMap.values())
                    .map(scores => MathUtils.average(scores));

                let percentiles = [
                    {
                        name: '90% or more',
                        matches: (val) => val >= 90,
                        color: 'limegreen',
                        count: 0
                    },
                    {
                        name: '80% to below 90%',
                        matches: (val) => val >= 80 && val < 90,
                        color: 'gold',
                        count: 0
                    },
                    {
                        name: '70% to below 80%',
                        matches: (val) => val >= 70 && val < 80,
                        color: 'orangered',
                        count: 0
                    },
                    {
                        name: '60% to below 70%',
                        matches: (val) => val >= 60 && val < 70,
                        color: 'steelblue',
                        count: 0
                    },
                    {
                        name: 'Less than 60%',
                        matches: (val) => val < 60,
                        color: 'orchid',
                        count: 0
                    },
                ];

                for (let i = 0; i < listOfAverages.length; i++) {
                    for (let j = 0; j < percentiles.length; j++) {
                        if (percentiles[j].matches(listOfAverages[i])) {
                            percentiles[j].count++;
                            break;
                        }
                    }
                }
                let filteredPercentiles = percentiles.filter(p => p.count > 0);
                return {
                    labels: filteredPercentiles.map(p => p.name),
                    data: filteredPercentiles.map(p => p.count),
                    colors: filteredPercentiles.map(p => p.color)
                }
            }
        }
    }
</script>
